import type { Config, Options } from '@core/images-ui/types';
import { toImageCdnSrc } from '@core/images/toImageCdnSrc';

export type ImageTransformOptions = {
  aspectRatio?: Config['aspectRatio'];
  color?: Config['color'];
  crop?: Config['crop'];
  dpr?: Config['devicePixelRatio'];
  effect?: Config['effect'];
  fetchFormat?: Config['format'];
  format?: Config['format'];
  height?: Config['height'];
  quality?: Config['quality'];
  width?: Config['width'];
  x?: Config['x'];
  y?: Config['y'];
};

/**
 * Service-agnostic image URL builder. Reads IMAGE_CDN_BASE_URL from env,
 * so the underlying CDN (Cloudinary, PixelForge, etc.) can be switched by
 * changing that env var without a code deploy.
 *
 * DO NOT use both width and height simultaneously or aspect ratio may be wrong.
 */
export const toImageCdnUrl = (
  imageUrl: string,
  transformations: ImageTransformOptions = {},
  blur: number | null = null,
): string => {
  const opts = {
    src: imageUrl,
    ...(transformations.aspectRatio != null && {
      aspectRatio: transformations.aspectRatio,
    }),
    crop: transformations.crop ?? 'scale',
    ...(transformations.dpr != null && {
      devicePixelRatio: transformations.dpr,
    }),
    color: transformations.color,
    effect: transformations.effect,
    format: transformations.format ?? transformations.fetchFormat ?? 'auto',
    height: transformations.height,
    quality: transformations.quality ?? 'auto',
    width: transformations.width,
    x: transformations.x,
    y: transformations.y,
  } as { src: string } & Options;

  return toImageCdnSrc(opts, blur);
};
